<script setup>
/**
 * Selo "Número da Equipe".
 *
 * Discreto, segue o padrão visual da aplicação (tokens n-slate) e é usado tanto
 * no painel de informações do contato quanto na listagem lateral de conversas.
 *
 * Nos cards de atendimento a variante `iconOnly` mostra só o ícone de grupo e
 * joga o texto para o tooltip — o card fica compacto e a informação continua
 * disponível no hover, junto do telefone quando o contato tem um.
 */
import { computed } from 'vue';

const props = defineProps({
  compact: {
    type: Boolean,
    default: false,
  },
  iconOnly: {
    type: Boolean,
    default: false,
  },
  phone: {
    type: String,
    default: '',
  },
});

const FULL_LABEL = 'Contato interno: excluído dos processamentos automáticos';

const tooltipLabel = computed(() => {
  if (!props.iconOnly) return FULL_LABEL;

  const phone = String(props.phone || '').trim();
  return phone ? `Número da Equipe: ${phone}` : 'Número da Equipe';
});
</script>

<template>
  <span
    v-if="iconOnly"
    v-tooltip.top="tooltipLabel"
    class="i-lucide-users-round size-4 shrink-0 text-n-slate-11"
    role="img"
    :aria-label="tooltipLabel"
  />
  <span
    v-else
    v-tooltip.top="tooltipLabel"
    class="inline-flex items-center gap-1 rounded-md border border-n-slate-5 bg-n-slate-3 font-medium text-n-slate-11 whitespace-nowrap"
    :class="compact ? 'px-1 py-0 text-[10px]' : 'px-1.5 py-0.5 text-xs'"
  >
    <span
      class="i-lucide-users-round"
      :class="compact ? 'size-2.5' : 'size-3'"
    />
    <span>Número da Equipe</span>
  </span>
</template>
